import { APIModel } from '@shared/interfaces';

import { Language } from '@/organisations/models';

import { NestedQuestion } from './question.model';

export const orderOffset = 1000;

export class TaxQuestion implements APIModel {
    id = -1;
    question?: NestedQuestion;
    questionId = -1;
    order = 0;
    numResponses?: number;
    required = false;

    localize(language: Language) {
        this.question?.localize(language);
    }

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.question = data.question != null ? new NestedQuestion().deserialize(data.question) : new NestedQuestion();
        this.questionId = this.question.id;
        this.order = data.order ?? 0;
        this.numResponses = data.num_responses ?? undefined;
        this.required = data.required ?? false;
        return this;
    }

    serialize() {
        return {
            order: this.order,
            'question_id': this.questionId,
        };
    }

    static Sort(q1: TaxQuestion, q2: TaxQuestion): number {
        return q1.order - q2.order;
    }
}
